// td-desktop-search-bar: Handles desktop search bar logic
if (!customElements.get("td-desktop-search-bar")) {
  class TdDesktopSearchBar extends HTMLElement {
    connectedCallback() {
      this.init();
      this.addEventListeners();
    }

    init() {
      this.barInput = this.querySelector('.search__input');
      this.searchButton = this.querySelector('.search__button');
      this.closeButton = this.querySelector('.reset__button');
      this.nav = document.querySelector('.td-header .header__inline-menu');
      this.header = document.querySelector('.td-header header');
      const path = window.location.pathname;
      if (path == '/search') {
        if (this.header) {
          this.header.classList.add('search-section');
        }
      }
    }

    addEventListeners() {
      const barInput = this.barInput;
      const searchButton = this.searchButton;
      const closeButton = this.closeButton;
      const nav = this.nav;
      const header = this.header;
      const headerIcons = document.querySelector('.header__icons');
      
      function toggleCornerLinks(hide) {
        if (!headerIcons) return;
        var links = headerIcons.querySelectorAll('.td-header__corner-link');
        links.forEach(function(link) {
          link.style.display = hide ? 'none' : '';
        });
      }

      if (barInput) {
        barInput.addEventListener('focus', function () {
          this.closest('header').classList.toggle('search-bar-open');
          if (nav) {
            this.style.width = `${nav.offsetWidth + 160}px`;
          }
          toggleCornerLinks(true);
        });
        barInput.addEventListener('focusout', function () {
          if (this.value) return;
          this.closest('header').classList.remove('search-bar-open');
          this.style.width = '25px';
          toggleCornerLinks(false);
        });
      }
      if (searchButton) {
        searchButton.addEventListener('click', function () {
          this.classList.toggle('btn-search-close');
          if (barInput) {
            barInput.focus();
          }
        });
      }
      if (closeButton) {
        closeButton.addEventListener('click', function () {
          if (barInput) {
            setTimeout(() => {
              barInput.blur();
            }, 100);
          }
        });
      }
    }
  }
  customElements.define("td-desktop-search-bar", TdDesktopSearchBar);
}

// td-mobile-drawer-slider-nav: Handles mobile drawer slider navigation
if (!customElements.get("td-mobile-drawer-slider-nav")) {
  class TdMobileDrawerSliderNav extends HTMLElement {
    connectedCallback() {
      this.init();
      this.addEventListeners();
    }

    init() {
      this.sliderPanels = this.querySelectorAll('.td-mobile-menu-slider-panel');
      this.mainLinks = this.querySelectorAll('.td-mobile-menu-slider-main-link');
      this.backButtons = this.querySelectorAll('.td-mobile-menu-slider-back');
      this.closeButtons = this.querySelectorAll('.td-mobile-menu-header__close');
      this.detailsMenu = document.getElementById('Details-menu-drawer-container');
      this.detailsMenuContainer = document.getElementById('td-mobile-drawer');
      this.detailsSummary = document.querySelector('.header__icon--summary');
    }

    showPanel(panelName) {
      this.sliderPanels.forEach(panel => {
        panel.classList.remove('active-menu', 'slide-left', 'slide-right');
        if (panel.dataset.panel === panelName) {
          panel.classList.add('active-menu');
        } else if (panelName !== 'main') {
          if (panel.classList.contains('td-mobile-menu-slider-panel--main')) {
            panel.classList.add('slide-left');
          }
        } else {
          if (!panel.classList.contains('td-mobile-menu-slider-panel--main')) {
            panel.classList.add('slide-right');
          }
        }
      });
    }

    addEventListeners() {
      this.mainLinks.forEach(link => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          const targetPanel = link.dataset.panel;
          this.showPanel(targetPanel);
        });
      });

      this.backButtons.forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          this.showPanel('main');
        });
      });

      this.closeButtons.forEach(btn => {
        btn.addEventListener('click', (e) => {
          this.showPanel('main');
          document.body.classList.remove('overflow-hidden');
          // Close the menu drawer after resetting
          if (this.detailsMenu && this.detailsMenuContainer && this.detailsSummary) {
            this.detailsMenu.open = false;
            document.body.classList.remove(`overflow-hidden-${this.detailsMenuContainer.dataset.breakpoint}`);
            this.detailsSummary.setAttribute('aria-expanded', 'false');
          }
        });
      });
    }
  }
  customElements.define("td-mobile-drawer-slider-nav", TdMobileDrawerSliderNav);
}

// td-mega-menu: Handles mega menu logic
if (!customElements.get("td-mega-menu")) {
  class TdMegaMenu extends HTMLElement {
    connectedCallback() {
      this.init();
      this.addEventListeners();
      this.setupObservers();
    }

    init() {
      this.details = Array.from(this.querySelectorAll("details.mega-menu"));
      this.targetElements = Array.from(this.querySelectorAll('.mega-menu__content'));
    }

    addEventListeners() {
      if (this.details.length) {
        this.details.map(elem => {
          elem.addEventListener("toggle", function () {
            let content = this.querySelector(".mega-menu__content");
            if (content) {
              content.classList.toggle('display-menu');
              content.classList.toggle('fade-in');
            }
          });
        });
      }
    }

    setupObservers() {
      if (!this.targetElements.length) return;
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 1
      };
      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.target.classList.contains('display-menu') && !entry.isIntersecting) {
            const details = entry.target.parentNode;
            window.addEventListener('scroll', () => {
              details.open = false;
            });
          }
        });
      }, options);

      this.targetElements.map(elem => {
        observer.observe(elem);
      });
    }
  }
  customElements.define("td-mega-menu", TdMegaMenu);
}

// td-mobile-search-toggle: Handles mobile search toggle logic
if (!customElements.get("td-mobile-search-toggle")) {
  class TdMobileSearchToggle extends HTMLElement {
    connectedCallback() {
      this.init();
      this.addEventListeners();
    }

    init() {
      this.searchBtn = this.querySelector('.header__search');
      this.mobileHeader = document.querySelector('.td-header');
      this.body = document.querySelector('body');
    }

    addEventListeners() {
      if (this.searchBtn) {
        this.searchBtn.addEventListener('click', () => {
          if (this.mobileHeader && this.mobileHeader.classList.contains('menu-open')) {
            this.body.classList.add('open-mobile-nav-search');
          }
        });
      }
    }
  }
  customElements.define("td-mobile-search-toggle", TdMobileSearchToggle);
}

if (!customElements.get("sticky-header")) {
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
      this.addEventListeners();
      this.setupObservers();
    }

    init() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
    }

    addEventListeners() {
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
    }

    setupObservers() {
      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      // this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
}
